/*
 * SSEDIT
 * Edit made to riot-functional-trainer.js:
 * Added custom Type/Configuration filtering for the
 * Riot Functional Trainer product page.
 */


document.addEventListener('DOMContentLoaded', function () {

  const PRODUCT_URL = '/products/riot-mrr-functional-trainer';

  const style = document.createElement('style');
  style.textContent = `
  variant-picker[data-url="${PRODUCT_URL}"] {
    opacity: 1;
    transition: opacity 0.08s ease;
  }

  variant-picker[data-url="${PRODUCT_URL}"].riot-updating {
    opacity: 0;
  }
`;
  document.head.appendChild(style);


  function normalise(value) {
    return value.toLowerCase().trim();
  }


  function hideVariantPicker() {

    const picker = document.querySelector(
      `variant-picker[data-url="${PRODUCT_URL}"]`
    );

    if (picker) {
      picker.classList.add('riot-updating');
    }

  }


  function resetDependentOptions(picker) {

    const weightField = picker.querySelector(
      'fieldset[data-option="Weight Stack & Height"]'
    );

    const configField = picker.querySelector(
      'fieldset[data-option="Configuration"]'
    );


    const firstWeight = weightField?.querySelector(
      'input.js-option'
    );

    const firstConfig = configField?.querySelector(
      'input.js-option:not([hidden])'
    );


    if (firstWeight) {
      firstWeight.checked = true;
    }


    if (firstConfig) {

      firstConfig.checked = true;

      requestAnimationFrame(() => {

        firstConfig.dispatchEvent(
          new Event('change', {
            bubbles: true
          })
        );

      });

    }

  }


  function filterConfiguration() {

    const picker = document.querySelector(
      `variant-picker[data-url="${PRODUCT_URL}"]`
    );

    if (!picker) return;


    const typeInput = picker.querySelector(
      'fieldset[data-option="Type"] input:checked'
    );


    const configField = picker.querySelector(
      'fieldset[data-option="Configuration"]'
    );


    if (!typeInput || !configField) return;


    const type = normalise(typeInput.value);


    const allowed = type === 'standalone'
      ? [
          'wall-backed',
          'freestanding',
          'wall-mounted'
        ]
      : [
          '425 crossmember',
          '725 crossmember',
          '1075 crossmember'
        ];


    const options = configField.querySelectorAll(
      'input.js-option'
    );


    let firstAvailable = null;


    options.forEach(input => {

      const label = configField.querySelector(
        `label[for="${input.id}"]`
      );

      if (!label) return;


      const show = allowed.includes(
        normalise(input.value)
      );


      label.hidden = !show;
      input.hidden = !show;


      if (show && !firstAvailable) {
        firstAvailable = input;
      }

    });


    const current = configField.querySelector(
      'input:checked'
    );


    if (
      !current ||
      !allowed.includes(normalise(current.value))
    ) {

      if (firstAvailable) {

        firstAvailable.checked = true;

        requestAnimationFrame(() => {

          firstAvailable.dispatchEvent(
            new Event('change', {
              bubbles: true
            })
          );

        });

      }

    }


    requestAnimationFrame(() => {
      picker.classList.remove('riot-updating');
    });

  }


  // Reset dependent options when Type changes
document.addEventListener(
  'change',
  function (event) {

    if (
      event.target.matches(
        'fieldset[data-option="Type"] input'
      )
    ) {

      hideVariantPicker();

      setTimeout(() => {

        const picker = document.querySelector(
          `variant-picker[data-url="${PRODUCT_URL}"]`
        );

        if (!picker) return;


        const weightField = picker.querySelector(
          'fieldset[data-option="Weight Stack & Height"]'
        );

        const configField = picker.querySelector(
          'fieldset[data-option="Configuration"]'
        );


        const firstWeight = weightField?.querySelector(
          'input.js-option:not([hidden])'
        );

        const firstConfig = configField?.querySelector(
          'input.js-option:not([hidden])'
        );


        if (firstWeight && !firstWeight.checked) {

          firstWeight.click();

        }


        if (firstConfig && !firstConfig.checked) {

          firstConfig.click();

        }


        filterConfiguration();


      }, 250);

    }

  }
);


  // Initial load filtering
  filterConfiguration();


  // Shopify variant update finished
  document.addEventListener(
    'on:variant:change',
    function () {

      requestAnimationFrame(() => {
        filterConfiguration();
      });

    }
  );


  // Shopify variant replacement starting
  document.addEventListener(
  'on:variant:before-replace-element',
  function () {
    hideVariantPicker();
  }
);

});



